export enum EBackgroundTypes {
  WORLD = 'WORLD',
  SEXAGON = 'SEXAGON',
  RECTANGLE = 'RECTANGLE',
  DOCUMENTS = 'DOCUMENTS',
  DETAILED_DOCUMENTS = 'DETAILED_DOCUMENTS',
  MAP_LAYERS = 'MAP_LAYERS',
  MAP_LAYERS_RIGHT = 'MAP_LAYERS_RIGHT',
}

export enum EIllustrationTypes {
  LOCATIONS = 'LOCATIONS',
  TRUST = 'TRUST',
  PROOF = 'PROOF',
  ROCKET = 'ROCKET',
  IDEA = 'IDEA',
  MEDIA = 'MEDIA',
  CERTIFICATE = 'CERTIFICATE',
  WEBSHOP = 'WEBSHOP',
  EMPTY_SEARCH = 'EMPTY_SEARCH',
  MAP_LAYERS = 'MAP_LAYERS',
  CHAIN_MAPPING = 'CHAIN_MAPPING',
}

export enum EItemTypes {
  MAP_LAYERS = 'MAP_LAYERS',
  DOCUMENT = 'DOCUMENT',
  PRODUCT = 'PRODUCT',
  IMPACT_CLAIM = 'IMPACT_CLAIM',
  PARTNER = 'PARTNER',
  LOCATION = 'LOCATION',
  COMPONENT = 'COMPONENT',
  COMPONENT_CHAIN = 'COMPONENT_CHAIN',
  CHAIN_MAPPING = 'CHAIN_MAPPING',
}
